import { FC } from "react"
import { Recommendation } from "../../types/LabReport"
import { Recommendation as RecommendationMessage } from "./Recommendation"

interface RecommendationsProps {
  recommendations: Recommendation[]
}

export const Recommendations: FC<RecommendationsProps> = ({ recommendations }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900">Recommendations</h3>
      <div className="mt-2 space-y-6">
        {recommendations.length > 0 ? (
          <>
            {recommendations.map((recommendation, i) => (
              <RecommendationMessage
                key={i}
                title={recommendation.testName}
                description={recommendation.message}
                type={"warning"}
              />
            ))}
          </>
        ) : (
          <div className="flex h-32 items-center justify-center text-gray-600">No recommendations found</div>
        )}
      </div>
    </div>
  )
}
